import type { Company } from '@/constants/companies'

import Asset from '@/components/ui/asset'
import Button from '@/components/ui/button'
import SegmentBar from '@/components/generals/segment-bar'
import { formatMoney } from '@/lib/companies'

interface ProfileAccountProps {
    company: Company
    onOpen: () => void
}

export default function ProfileAccount({ company, onOpen }: ProfileAccountProps) {
    const initial = (
        <span className='caption-style text-soft'>
            {company.name.slice(0, 1)}
        </span>
    )

    return (
        <li>
            <Button
                variant='item'
                size='md'
                onClick={onOpen}
                aria-label={`Open ${company.name} details`}
                className='items-center px-2 py-2'
            >
                <span className='bg-muted flex size-8 shrink-0 items-center justify-center rounded-lg shadow-[0px_0px_0px_1px_#232323]'>
                    {company.logo ? (
                        <Asset
                            src={company.logo}
                            alt=''
                            width={1}
                            height={1}
                            fit='contain'
                            fallback={initial}
                            className='size-4'
                        />
                    ) : initial}
                </span>
                <span className='flex min-w-0 flex-1 flex-col gap-1'>
                    <span className='truncate' data-mdlfy-cms={`companies:${company.id}:name`}>
                        {company.name}
                    </span>
                    <span className='caption-style text-subtle truncate'>
                        <span>{company.openDeals}</span> open deals · <span>{company.tags.join(', ')}</span>
                    </span>
                </span>
                <span className='flex shrink-0 flex-col items-end gap-1.5 tabular-nums'>
                    <span className='flex items-center gap-1'>
                        <span className='text-muted-foreground'>$</span>
                        <span>{formatMoney(company.pipelineValue)}</span>
                    </span>
                    <SegmentBar percent={company.winProbability} className='w-[60px]' />
                </span>
            </Button>
        </li>
    )
}
